import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';





import {
  AppLayoutComponent,
  AuthGuard,
  LoginComponent,
  NotfoundComponent,
  RegisterComponent,
} from 'shared';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          children: [
            {
              path: '',
              data: { breadcrumb: 'Πινακας ελεγχου' },
              loadChildren: () =>
                import('./pages/dashboard/dashboard.module').then(
                  (m) => m.DashboardModule
                ),
              canActivate: [AuthGuard],
            },
        
            {
              path: 'clients',
              data: { breadcrumb: 'Ασφαλισμένοι' },
              loadComponent: () => import('./pages/insured-clients/insured-clients.component').then(m => m.InsuredClientsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'contracts',
              data: {
                breadcrumb: 'Ασφαλιστήρια Συμβόλαια',
              },
              loadComponent: () => import('./pages/contracts/contracts.component').then(m => m.ContractsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'insurance_products',
              data: {
                breadcrumb: 'Ασφαλιστήρια Προϊόντα',
              },
              loadComponent: () => import('./pages/insurance-products/insurance-products.component').then(m => m.InsuranceProductsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'insurance_claims',
              data: {
                breadcrumb: 'Ασφαλιστικές Απαιτήσεις',
              },
              loadComponent: () => import('./pages/claims/claims.component').then(m => m.InsuranceClaimsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'reports',
              data: { breadcrumb: 'Αναφορές' },
              loadComponent: () => import('./pages/reports/reports.component').then(m => m.ReportsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'affiliate_network',
              data: {
                breadcrumb: 'Συνεργαζόμενο Δίκτυο',
              },
              loadChildren: () =>
                import(
                  './pages/affiliate-network/affiliate-network.module'
                ).then((m) => m.AffiliateNetworkModule),
              canActivate: [AuthGuard],
            },
          ],
        },
        { path: 'login', component: LoginComponent },
        {
          path: 'register',
          component: RegisterComponent,
        },
        {
          path: 'notfound',
          component: NotfoundComponent,
          canActivate: [AuthGuard],
        },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
